import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const FinishOauthSignupModalLoadable = clientOnlyLazy({
  loader: () => import('./FinishOauthSignupModal.dynamic'),
  loading: LoadingModal,
});
